import { InjectionToken } from '@angular/core';
import { TranslationRepository } from '../repositories/translation.repository';

/**
 * Domain Injection Tokens
 * Tokens de inyección para las interfaces del dominio
 */
export const TRANSLATION_REPOSITORY_TOKEN = new InjectionToken<TranslationRepository>('TranslationRepository');
